/**
 * Checks that arr1 matches arr2 by value
 *
 * @param arr1 - The first array
 * @param arr2 - The second array
 * @param itemComparitor - The item comparison check function
 * @returns true if the array items match
 */
export function arrayMatch<T, T2>(arr1: T[], arr2: T2[], itemComparitor: (item1: T, item2: T2) => boolean): boolean;
export function arrayMatch<T, T2 extends T>(
    arr1: T[],
    arr2: T2[],
    itemComparitor?: (item1: T, item2: T2) => boolean,
): boolean;
export function arrayMatch<T, T2>(
    arr1: T[],
    arr2: T2[],
    itemComparitor: (item1: T, item2: T2) => boolean = (item1, item2) => item1 === (item2 as unknown as T),
): boolean {
    return arr1.length === arr2.length && arr1.every((val1, index) => itemComparitor(val1, arr2[index]));
}
